import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { InputTextAreaComponent } from './input-textArea.component';

import {MatInputModule} from '@angular/material/input';

@NgModule({
  imports: [
    CommonModule, 
    FormsModule,
    ReactiveFormsModule,
    MatInputModule
  ],
  declarations: [
    InputTextAreaComponent
  ],
  exports: [
    InputTextAreaComponent
  ]
})
export class InputTextAreaModule {}
